import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "parallax-wrapper" }
const _hoisted_2 = { class: "background-image" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "parallax-foreground" }


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseParallax',
  props: { image: { type: String, required: true } },
  setup(__props) {



const scroll = () => {
  const el = document.querySelector('.parallax-foreground')
  el?.scrollIntoView({ behavior: 'smooth' })
}

return (_ctx: any,_cache: any) => {
  const _component_base_picture = _resolveComponent("base-picture")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", {
      class: "parallax-background",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (scroll()))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_base_picture, { name: __props.image }, null, 8, ["name"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "title")
      ])
    ]),
    _createElementVNode("section", _hoisted_4, [
      _renderSlot(_ctx.$slots, "content")
    ])
  ]))
}
}

})